import React, { useEffect, useMemo, useState } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import {
  deleteCategoryApi,
  deleteCoupons,
  deleteEmailTemplate,
  deletePackageApi,
  deleteShippingApi,
  getCategoriesApi,
  getCouponsManagementApi,
  getEmailTemplate,
  getPackageSizeApi,
  getShippingChargeApi,
} from "../../apiHelper/authService";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setSelectedCategory,
  setSelectedCoupon,
  setSelectedEmailTemplate,
  setSelectedPackage,
  setSelectedShippingCharge,
} from "../../redux/authModalSlice";
const CouponsManagementTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [couponLoading, setCouponLoading] = useState(false);
  const navigate = useNavigate();

  console.log("Selected Coupon Id ", selectedShippingId);

  const dispatch = useDispatch();

  const [itemsPerPage] = useState(10);

  const { user } = useSelector((state) => state.authModal);
  // const [categories, setCategories] = useState();
  const [shippingCharges, setShippingCharges] = useState();

  const fromCountry = user?.from;
  const toCountry = user?.to;

  const [loading, setLoading] = useState(false);

  const getShipCharges = async () => {
    setLoading(true);
    setCouponLoading(true);

    // const toastId = toast.loading("Fetching Email Templates...");

    try {
      const data = await getCouponsManagementApi();
      // setCategories(data);
      setShippingCharges(data);
      setCouponLoading(false);

      // toast.success("Email Templates fetched successfully!", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      // toast.error(
      //     err?.message || "Something went wrong while fetching email templates.",
      //     { id: toastId }
      // );
    } finally {
      setLoading(false);
      setCouponLoading(false);
    }
  };

  useEffect(() => {
    getShipCharges();
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredData = shippingCharges?.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalItems = filteredData?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredData?.slice(startIdx, startIdx + itemsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedShippingId) return;

    setLoading(true);

    // const toastId = toast.loading("Deleting...");

    try {
      const data = await deleteCoupons({ couponId: selectedShippingId });
      // getPackageSizes()
      getShipCharges();

      // toast.success("Deleted", { id: toastId });
      const modalEl = document.getElementById("exampleModalEdit");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err || "Something went wrong.");
    } finally {
      setLoading(false);
      // setSelectedCategoryId(null)
    }
  };

  function getTotalVal(
    taxPercent,
    internationCharge,
    localCharge,
    humanCharge
  ) {
    const subtotal = internationCharge + localCharge + humanCharge;
    const taxAmount = (subtotal * taxPercent) / 100;
    const total = subtotal + taxAmount;
    return total.toFixed(2);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getValueByKeyPath = (obj, keyPath) => {
    return keyPath.split(".").reduce((acc, key) => acc?.[key], obj) ?? "";
  };

  const sortedItems = useMemo(() => {
    if (!sortConfig.key) return currentItems;

    return [...currentItems].sort((a, b) => {
      let valA = getValueByKeyPath(a, sortConfig.key);
      let valB = getValueByKeyPath(b, sortConfig.key);

      const isNumberLike = (val) =>
        typeof val === "number" ||
        (typeof val === "string" && /^[\d.,$]+$/.test(val.trim()));

      if (isNumberLike(valA) && isNumberLike(valB)) {
        const parseNumericValue = (val) =>
          typeof val === "number"
            ? val
            : parseFloat(val.replace(/[^0-9.-]+/g, "")) || 0;

        valA = parseNumericValue(valA);
        valB = parseNumericValue(valB);
      } else {
        valA = valA?.toString().toLowerCase() || "";
        valB = valB?.toString().toLowerCase() || "";
      }

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [currentItems, sortConfig]);

  const getSortIcon = (key) => {
    const baseClass = "transition-all duration-300 ease-in-out";

    if (sortConfig.key !== key) {
      // Neutral icon when column is not sorted
      return (
        <Icon
          icon="lucide:chevrons-up-down"
          className={`${baseClass} text-muted`}
        />
      );
    }

    return sortConfig.direction === "asc" ? (
      <Icon icon="lucide:chevron-up" className={`${baseClass} text-muted`} />
    ) : (
      <Icon icon="lucide:chevron-down" className={`${baseClass} text-muted`} />
    );
  };


  const formatAmount = (amount) => {
  if (amount >= 1_000_000) return `${(amount / 1_000_000).toFixed(1)}M`;
  if (amount >= 1_000) return `${(amount / 1_000).toFixed(1)}K`;
  return `${amount.toFixed(2)}`;
};


 const formatNumbers = (input) => {
  if (input >= 1_000_000) return `${(input / 1_000_000)}M`;
  if (input >= 1_000) return `${(input / 1_000)}K`;
  return `${input}`;
};


  return (
    <>
      <div className="card basic-data-table">
        {/* <div className="card-header d-flex flex-row justify-content-between align-items-center">
                    <h5 className="card-title mb-0">Shipment Charges</h5>

                    <div className='d-flex flex-row gap-3 align-items-center'>

                        <div className="icon-field">
                            <input
                                type="text"
                                name="search"
                                className="form-control form-control-sm w-auto rounded-3"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <span className="icon">
                                <Icon icon="ion:search-outline" />
                            </span>
                        </div>


                        <Link to={"/add-ship-charges"}>
                            <button
                                type="button"
                                className="btn btn-primary radius-8 px-20 py-11 d-flex align-items-center gap-2"
                            >
                                Add New Shipment Charge
                                <Icon
                                    icon="mingcute:add-line"
                                    className="text-xl"
                                />
                            </button></Link> </div>


                </div> */}

        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <form className="navbar-search">
              <input
                type="text"
                className="bg-base h-40-px w-auto"
                name="search"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
          </div>
          <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <Link
              to={"/create-coupons"}
              className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Create Coupons
            </Link>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive" style={{ minHeight: "50vh" }}>
            <table
              className="table vertical-striped-table mb-0"
              id="dataTable"
              // data-page-length={10}
            >
              <thead>
                <tr>
                  {/* <th scope="col">Coupon Code</th> */}

                  <th
                    onClick={() => handleSort("coupon_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Code 
                      
                      {/* {getSortIcon("coupon_name")} */}
                    </div>
                  </th>

                  {/* <th scope="col">Min. Amount</th> */}

                  <th
                    onClick={() => handleSort("min_order_amount")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Min Amt 
                      {/* {getSortIcon("min_order_amount")} */}
                    </div>
                  </th>

                  {/* <th scope="col">	Max. Amount</th> */}

                  <th
                    onClick={() => handleSort("max_order_amount")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Max Amt 
                      {/* {getSortIcon("max_order_amount")} */}
                    </div>
                  </th>

                  {/* <th scope="col">	Min. Quantity</th> */}

                  <th
                    onClick={() => handleSort("min_order_quantity")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Min. Qty 
                      {/* {getSortIcon("min_order_quantity")} */}
                    </div>
                  </th>
                  {/* <th scope="col">	User Limit</th> */}

                  <th
                    onClick={() => handleSort("user_usage_count")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      User Limit 
                      {/* {getSortIcon("user_usage_count")} */}
                    </div>
                  </th>
                  <th scope="col"> Exp. Date</th>

                  <th
                    onClick={() => handleSort("amount")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Discount Value 
                      {/* {getSortIcon("amount")} */}
                    </div>
                  </th>
                  {/* <th scope="col">			Discount Value</th> */}
                  <th scope="col"> Type</th>
                  {/* <th scope="col">		Coupon Type</th> */}

                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {couponLoading ? (
                  <tr>
                    <td colSpan="10" className="text-center py-20">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          color: "#243E85",
                          width: "2rem",
                          height: "2rem",
                          borderWidth: "0.3em",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : currentItems?.length > 0 ? (
                  sortedItems?.map((shipCharge) => (
                    <tr key={shipCharge.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {shipCharge?.coupon_name}
                          </h6>
                        </div>
                      </td>

                      <td className="text-start">
                        <div className="d-flex justify-content-end w-100 align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {/* ${shipCharge?.min_order_amount.toFixed(2)} */}
                              ${formatAmount(shipCharge?.min_order_amount || 0)}
                          </h6>
                        </div>
                      </td>

                      <td className="text-start">
                        <div className="d-flex justify-content-end w-100 align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {/* ${shipCharge?.max_order_amount.toFixed(2)} */}

                            ${formatAmount(shipCharge?.max_order_amount || 0)}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipCharge?.min_order_quantity}
                            {/* {formatNumbers(shipCharge?.min_order_quantity || 0)} */}

                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipCharge?.user_usage_count}
                            {/* {formatNumbers(shipCharge?.user_usage_count || 0)} */}

                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {formatDate(shipCharge?.expiration_date)}
                          </h6>
                        </div>
                      </td>

                      <td className="text-start">
                        <div className="d-flex justify-content-end w-100 align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipCharge.type === "PERCENTAGE"
                              ? `${shipCharge?.amount}%`
                              : `$${shipCharge?.amount.toFixed(2)}`}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipCharge.type === "PERCENTAGE"
                              ? "%"
                              : "$"}
                          </h6>
                        </div>
                      </td>

                      {/* <td>
                                                <div className="d-flex align-items-center">
                                                    <h6
                                                        className="text-md mb-0 fw-medium flex-grow-1 "


                                                    >

                                                        ${getTotalVal(shipCharge?.taxes, shipCharge?.international_courier_charge, shipCharge?.local_delivery_charge, shipCharge?.human_resource_charge)}
                                                    </h6>
                                                </div>
                                            </td> */}

                      {/* 
                                            <td>
                                                <span style={{ width: "60%", margin: "auto" }}
                                                    className={`${shipCharge?.shipping_charges_type === "AIR"
                                                        ? "bg-success-focus text-success-main"
                                                        : "bg-warning-focus text-warning-main"
                                                        } px-24 py-4 rounded-pill fw-medium text-sm d-flex align-items-center gap-2 justify-content-center`}
                                                >
                                                    {shipCharge?.shipping_charges_type === "AIR" ? (
                                                        <>
                                                            <Icon icon="mdi:airplane" width="16" height="16" />
                                                            Air
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Icon icon="mdi:ferry" width="16" height="16" />
                                                            Ship
                                                        </>
                                                    )}
                                                </span>
                                            </td> */}

                      <td>
                        {/* <Link
                          to={"/create-coupons"}
                          onClick={() =>
                            dispatch(setSelectedCoupon(shipCharge))
                          }
                          className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        >
                          <Icon icon="lucide:edit" />
                        </Link> */}
                        <Link
                          onClick={() => setSelectedShippingId(shipCharge.id)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalEdit"
                          className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        >
                          <Icon icon="mingcute:delete-2-line" />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-16 text-muted">
                      No Coupons found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {filteredData?.length > itemsPerPage && (
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
              <span>
                Showing {startIdx + 1} to{" "}
                {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                {filteredData?.length} entries
              </span>
              <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <Icon icon="ep:d-arrow-left" className="text-xl" />
                  </button>
                </li>

                {[...Array(totalPages)].map((_, index) => (
                  <li className="page-item" key={index}>
                    <button
                      className={`page-link ${
                        currentPage === index + 1
                          ? "bg-primary-600 text-white"
                          : "bg-primary-50 text-secondary-light"
                      } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                      onClick={() => goToPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}

                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <Icon icon="ep:d-arrow-right" className="text-xl" />
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalEdit"
        tabIndex={-1}
        aria-labelledby="exampleModalEditLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                Confirm Deletion
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24 text-center">
              <p className="mb-4 fs-6 text-secondary">
                Are you sure you want to delete this item?
              </p>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponsManagementTable;
